export default "__VITE_ASSET__BVsdoYqW__"